import { render, staticRenderFns } from "./PortalSearchField.vue?vue&type=template&id=26861ff8&scoped=true&"
import script from "./PortalSearchField.vue?vue&type=script&lang=js&"
export * from "./PortalSearchField.vue?vue&type=script&lang=js&"
import style0 from "./PortalSearchField.vue?vue&type=style&index=0&id=26861ff8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26861ff8",
  null
  
)

export default component.exports